/* COOKBOOKS & GUIDES — soft fade-in + real-cart quick-add.
   Ported from the claude.ai/design prototype; the prototype's dummy
   buy buttons are wired to the real Shopify AJAX cart (/cart/add.js),
   then the site-wide cart drawer is told to slide in. */
(function () {
  "use strict";

  // Each section links this file, so the tag can appear several times — run once.
  if (window.__skCookbooksInit) return;
  window.__skCookbooksInit = true;

  /* ── Soft fade-in on scroll (JS-gated; no-JS shows everything) ── */
  document.documentElement.classList.add("js");
  var fx = Array.prototype.slice.call(document.querySelectorAll(".sk-cookbooks-fx:not(.vis)"));
  if (fx.length) {
    if (!("IntersectionObserver" in window)) {
      fx.forEach(function (el) { el.classList.add("vis"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("vis"); io.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      fx.forEach(function (el) { io.observe(el); });
    }
  }

  /* ── Quick-add → real cart → slide the drawer in ──────────── */
  var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-sk-cookbooks-add]"));
  buttons.forEach(function (btn) {
    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) { btn.setAttribute("disabled", "disabled"); return; }
    var label = btn.textContent;

    btn.addEventListener("click", function (ev) {
      ev.preventDefault();
      if (btn.hasAttribute("disabled")) return;
      btn.setAttribute("disabled", "disabled");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () {
          btn.classList.add("added");
          btn.textContent = btn.getAttribute("data-added-label") || "Added ✓";
          // sync header/drawer + slide the site-wide cart drawer in
          document.dispatchEvent(new CustomEvent("sk-cart:added", { detail: { open: true } }));
          setTimeout(function () {
            btn.classList.remove("added");
            btn.textContent = label;
            btn.removeAttribute("disabled");
          }, 1600);
        })
        .catch(function (err) {
          btn.removeAttribute("disabled");
          /* eslint-disable-next-line no-console */
          console.error("Cookbooks add-to-cart failed:", err);
        });
    });
  });

  /* ── "Other editions" rail: ‹ › click-scroll on desktop, native swipe on mobile ── */
  Array.prototype.slice.call(document.querySelectorAll("[data-sk-rail]")).forEach(function (rail) {
    var track = rail.querySelector("[data-rail-track]");
    var prev  = rail.querySelector("[data-rail-prev]");
    var next  = rail.querySelector("[data-rail-next]");
    if (!track) return;
    // distance per click = however many whole cards currently fit (min 1)
    function step() {
      var card = track.querySelector(".sk-cookbooks-card");
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 16;
      var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.9;
      var per = Math.max(1, Math.floor(track.clientWidth / w));
      return w * per;
    }
    // hide an arrow when there's nothing more that way (or nothing overflows)
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflowing = max > 1;
      if (prev) prev.hidden = !overflowing || track.scrollLeft <= 1;
      if (next) next.hidden = !overflowing || track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left:  step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
})();
